import React from 'react'
import girl from "../../Assets/images/pic1_1.jpg";
import revenue from "../../Assets/images/123.png";
import star from "../../Assets/images/1234.png";
import people from "../../Assets/images/people.png";

const HomeWhyUs = () => {
    return (
        <div className="aon-whycoose-area sf-curve-pos">
            <div className="container-fluid">
                <div className="sf-whycoose-section">
                    <div className="row sf-w-choose-bg-outer d-flex flex-wrap a-b-none">
                        {/* Left Section */}
                        <div className="col-md-7 margin-b-50 sf-w-choose-left-cell why-us">
                            <div className="sf-w-choose-info-left">
                                <div className="section-head">
                                    <div className="row">
                                        <div className="col-md-12  margin-b-50">
                                            <span className="aon-sub-title">Choose</span>
                                            <h2 className="sf-title">Why Choose us</h2>
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut labore et dolore magna
                                                aliqua.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="sf-w-choose margin-b-20">
                                    <div className="sf-w-choose-icon">
                                        <span>
                                            <img src={people} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-w-choose-info">
                                        <h4 className="sf-title s-18">Connect to new customers</h4>
                                        <p>
                                            Expand your reach and connect with fresh opportunities. Our strategies help you Connect to new customers, fostering growth and enhancing your market presence.
                                        </p>
                                    </div>
                                </div>
                                <div className="sf-w-choose margin-b-20">
                                    <div className="sf-w-choose-icon">
                                        <span>
                                            <img src={revenue} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-w-choose-info">
                                        <h4 className="sf-title s-18">Grow your revenue</h4>
                                        <p>
                                            Unlock untapped potential and boost your earnings. Our revenue-driven approach empowers businesses to grow their bottom line through strategic solutions and increased market share.
                                        </p>
                                    </div>
                                </div>
                                <div className="sf-w-choose">
                                    <div className="sf-w-choose-icon">
                                        <span>
                                            <img src={star} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-w-choose-info">
                                        <h4 className="sf-title s-18" >Build your online reputation</h4>
                                        <p>
                                            Cultivate a strong digital identity that resonates with your audience. Our expertise in online reputation management ensures your brand stands out, building trust and credibility in the virtual realm
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Right Section */}
                        <div className="col-md-5 sf-w-choose-bg-wrap sf-w-choose-right-cell">
                            <div
                                className="sf-w-choose-bg"
                                style={{ backgroundImage: `url(${girl})` }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default HomeWhyUs